import { useEffect, useState } from 'react';

/**
 * Relógio da tela: "há 12 min", "vence em 4 min" e a linha dos atrasados andam sozinhos, sem
 * esperar a próxima leitura do banco. Ao voltar para a aba (o vai e vem com o WhatsApp), acerta na
 * hora: o navegador atrasa os timers de aba escondida.
 */
export function useAgora(intervaloMs = 15_000): Date {
  const [agora, setAgora] = useState(() => new Date());

  useEffect(() => {
    const acertar = () => setAgora(new Date());
    const id = setInterval(acertar, intervaloMs);
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') acertar();
    };
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, [intervaloMs]);

  return agora;
}
